/**
 * This file is shared between nodejs and client, so don't put any import statement here.
 * Use require.
 *
 */

function firstWordOccurrence(str) {
  if (!str || !(typeof str === 'string')) {
    return str;
  }

  return str.match(/(^\w*)/)[1];
}

function firstNumberOccurrence(str) {
  if (!str || !(typeof str === 'string')) {
    return str;
  }

  return str.match(/(^\d*)/)[1];
}

module.exports = {
  firstWordOccurrence,
  firstNumberOccurrence,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/StringUtil.js